<app-input-label
    [label]="label"
    [labelPosition]="labelPosition"
    [for]="id"
    [isRequired]="isRequired"
    [isEditMode]="isEditMode">
    @if (isEditMode) {
        <kendo-datetimepicker
            class="bg-input text-input-foreground"
            [ngClass]="generateInputStyle()"
            [id]="id"
            [adaptiveTitle]="title | translate"
            [placeholder]="placeholder"
            [format]="format || defaultDateTimeFormat"
            [formatPlaceholder]="formatPlaceholder"
            [required]="isRequired"
            [max]="maxDate"
            [min]="minDate"
            [disabled]="isDisabled"
            [disabledDates]="disabledDates"
            [ngModel]="dateValue()"
            (valueChange)="onValueChange($event)"
            (focusin)="onFocusIn()"
            (focusout)="onFocusOut()">
            <kendo-datetimepicker-messages
                [today]="'Today' | translate"
                [dateTab]="'Date' | translate"
                [timeTab]="'Time' | translate"
                [now]="'Now' | translate"
                [accept]="'Accept' | translate"
                [cancel]="'Cancel' | translate" />
        </kendo-datetimepicker>
        <app-input-error [error]="error()?.[0]" />
    } @else {
        <div class="w-full truncate pt-1.5 pb-1">
            <span kendoTooltip [title]="dateValue() | datetime">
                {{ dateValue() | datetime }}
            </span>
        </div>
    }
</app-input-label>
